function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-256.9-108.321a1.018,1.018,0,0,0-.106.038q-6.229,2.989-12.457,5.981a.266.266,0,0,1-.243.006q-6.065-2.534-12.133-5.063c-.028-.012-.055-.026-.1-.046.044-.021.073-.037.1-.05l12.844-5.477a.23.23,0,0,1,.188-.009q5.93,2.251,11.861,4.5c.013,0,.025.012.038.017Z",
  transform: "translate(281.939 112.958)",
  fill: "#60d394"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M-256.984,303.277q-.817.39-1.634.779-5.478,2.629-10.955,5.261a.2.2,0,0,1-.186.007q-6.079-2.54-12.159-5.077c-.028-.012-.054-.026-.1-.049.11-.046.2-.085.294-.122q2.27-.919,4.54-1.839a.263.263,0,0,1,.218,0q3.636,1.519,7.272,3.037a.182.182,0,0,0,.166-.007q3.806-1.83,7.613-3.66a.321.321,0,0,1,.267-.015q2.282.781,4.567,1.555c.032.011.067.016.1.024Z",
  transform: "translate(282.022 -292.879)",
  fill: "#39a95e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M-257.063,571.816l-6.455,3.1q-3.067,1.473-6.134,2.946a.205.205,0,0,1-.186.007q-6.056-2.53-12.113-5.057l-.15-.065c.047-.022.078-.037.109-.05q2.231-.9,4.462-1.809a.212.212,0,0,1,.178,0q3.781,1.58,7.563,3.159a.214.214,0,0,0,.2-.008q3.953-1.9,7.908-3.8a.273.273,0,0,1,.185-.021q2.2.742,4.4,1.493a.411.411,0,0,1,.038.017Z",
  transform: "translate(282.101 -555.888)",
  fill: "#097b41"
});

var SvgFullStackDeveloper = function SvgFullStackDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.038,
    height: 22.5,
    viewBox: "0 0 25.038 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullStackDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/full_stack_developer.c0e200d7.svg";
export { ForwardRef as ReactComponent };